import { Link } from 'react-router-dom';
import ComicCard from '@/components/feature/ComicCard';
import { getNewComics, rankingComics } from '@/mocks/comics';

export default function RankingSection() {
  const newComics = getNewComics();

  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-10">
          {/* New Updates */}
          <div className="lg:col-span-2">
            <div className="flex items-center justify-between mb-6">
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-secondary-500">
                  <i className="ri-timer-flash-line text-background-50 text-sm"></i>
                </div>
                <div>
                  <h2 className="text-2xl font-heading font-bold text-foreground-900">最新上架</h2>
                  <p className="text-xs text-foreground-500 mt-0.5">刚刚上线的新鲜韩漫</p>
                </div>
              </div>
              <Link
                to="/category/all"
                className="flex items-center gap-1 text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap"
              >
                查看全部 <i className="ri-arrow-right-line text-xs"></i>
              </Link>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 md:gap-5">
              {newComics.map((comic) => (
                <ComicCard key={comic.id} comic={comic} />
              ))}
            </div>
          </div>

          {/* Ranking */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-trophy-line text-background-50 text-sm"></i>
              </div>
              <div>
                <h2 className="text-2xl font-heading font-bold text-foreground-900">阅读排行</h2>
                <p className="text-xs text-foreground-500 mt-0.5">人气最高的韩漫作品</p>
              </div>
            </div>
            <div className="bg-background-50 rounded-xl p-4 border border-background-200/70">
              {rankingComics.map((comic, index) => (
                <Link
                  key={comic.id}
                  to={`/comic/${comic.id}`}
                  className="flex items-center gap-3 py-3 px-2 rounded-lg hover:bg-background-100 transition-colors duration-200 group border-b border-background-200/70 last:border-b-0"
                >
                  <span className={`w-6 h-6 flex items-center justify-center rounded-full text-xs font-bold whitespace-nowrap ${
                    index < 3
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-200 text-foreground-500'
                  }`}>
                    {index + 1}
                  </span>
                  <div className="w-10 h-14 rounded overflow-hidden flex-shrink-0">
                    <img
                      src={comic.coverImage}
                      alt={comic.title}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors duration-200 line-clamp-1">
                      {comic.title}
                    </h3>
                    <div className="flex items-center gap-2 mt-1 text-[11px] text-foreground-500">
                      <span className="flex items-center gap-0.5">
                        <i className="ri-star-fill text-accent-500 text-[10px]"></i>
                        {comic.rating}
                      </span>
                      <span>{comic.status}</span>
                    </div>
                  </div>
                  {index < 3 && (
                    <span className="text-[10px] text-accent-600 bg-accent-100 px-1.5 py-0.5 rounded whitespace-nowrap">
                      <i className="ri-arrow-up-line text-[8px]"></i> 热门
                    </span>
                  )}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}